<div class="cart_tabs">
            <customer-select class="mx:hidden sm:block"></customer-select>
            <nz-tabset [nzSelectedIndex]="tabSelectedIndex"  (nzSelectedIndexChange)="onTabChange($event)" [nzTabBarExtraContent]="extraTemplate">
                <nz-tab [nzTitle]="('CART_TITLE' | translate) +'('+productList.length+')'">
                    <cart></cart>
                </nz-tab>
                <nz-tab [nzTitle]="('SAVE_FOR_LATER' | translate) +'('+wishList.length+')'">
                    <ng-template nz-tab>
                        <wishlist [wishList]="wishList"></wishlist>
                    </ng-template>
                </nz-tab>
            </nz-tabset>
            <ng-template #extraTemplate>
                <customer-select class="sm:hidden mx:block"></customer-select>
              </ng-template>
      </div>
